import { State } from './types';
import { PensionValidator } from '@/modules/pension/helpers/pension-validator';

export const PensionState: State = {
  // Auth user info state
  authUser: null,

  // Modals state
  modal: {
    lead: {
      open: false,
      success: false
    }
  },

  // Validator object
  validator: {
    lead: PensionValidator.lead()
  },

  // Loadings state
  loading: {
    sendLead: false,
    simulatorConfig: false,
    simulatorSubmit: false
  },

  // Errors state
  errors: {
    sendLead: false,
    simulatorConfig: false,
    simulatorSubmit: false
  },

  // Lead info state
  lead: {
    name: '',
    phone: '',
    email: '',
    type: 'contract',
    monthlyIncome: undefined,
    simulation: undefined
  },

  // Simulator states
  simulator: {
    config: {
      minAge: 0,
      agePlaceholder: 30,
      initialInvestment: 5000,
      monthlyInvestment: 100,
      riskLevel: 'low'
    },
    form: {
      age: 30,
      initialInvestment: 5000,
      monthlyInvestment: 100,
      riskLevel: 'low',
      totalValue: 0
    },
    chart: {
      labels: [],
      datasets: [
        {
          label: 'CDI',
          fill: true,
          pointStyle: 'circle',
          lineTension: 0,
          backgroundColor: 'rgb(249, 78, 125)',
          borderColor: 'rgb(255, 255, 255)',
          borderDash: [5, 5],
          data: undefined
        },
        {
          label: 'Previdência Warren',
          fill: true,
          pointStyle: 'circle',
          lineTension: 0,
          backgroundColor: '#EE2E5D',
          data: undefined
        }
      ]
    },
    result: undefined
  }
};
